import { FC, useCallback } from "react";
import { NetworkProfileMetrics, ValidExceptionStatuses } from "@app/compliance-connect/network-submission/interfaces";
import { QESButton } from "@app/shared/qes-standards/Button";
import { ExceptionsNavFilter } from "@app/exceptions/contexts/ExceptionsFiltersContext";
import { useHistory } from "react-router-dom";

interface NetworkProfileKeyPointsProps {
  metrics: NetworkProfileMetrics | undefined;
}

export const NetworkProfileKeyPoints: FC<NetworkProfileKeyPointsProps> = ({ metrics }) => {
  const history = useHistory();
    
  const navigateToExceptions = useCallback((customProjectId: number, projectName: string) => {
    const navFilter: ExceptionsNavFilter = {
      project: { key: customProjectId.toString(), name: projectName },
      statuses: ValidExceptionStatuses
        .map(s => ({ key: s.toString(), name: s.charAt(0).toUpperCase() + s.slice(1) })),
    };
    history.push("/exceptions/view", { exceptionsNavFilter: navFilter });
  }, [history]);
  
  return (
    <>
      { metrics &&
        <div className="compliance-connect-network-profile__card">
          <h4 className="compliance-connect-network-profile__card-title np-gray-border-bottom">Key Points</h4>
          <div className="compliance-connect-network-profile__card-content">
            <div className="compliance-connect-network-profile__card-values">
              <div className="compliance-connect-network-profile__card-highlight" aria-labelledby="gaps">{metrics?.gaps ?? "-"}</div>
              <div className="compliance-connect-network-profile__card-highlight" aria-labelledby="exceptions">
                <QESButton qesType="link"
                  onClick={() => navigateToExceptions(metrics?.customProjectId, metrics?.networkName)}
                  qesTestId={"compliance-connect-network-profile__card-highlight-exceptions"}>
                    {metrics?.exceptions ?? "-"}
                </QESButton>
              </div>
              <div className="compliance-connect-network-profile__card-highlight compliance-connect-network-profile__card-highlight--blue" aria-labelledby="regulator-comments">{metrics?.newRegulatorComments ?? "-"}</div>
            </div>
            <div className="compliance-connect-network-profile__card-labels">
              <div className="compliance-connect-network-profile__card-subtitle" id="gaps">Gaps</div>
              <div className="compliance-connect-network-profile__card-subtitle" id="exceptions">Exceptions</div>
              <div className="compliance-connect-network-profile__card-subtitle" id="regulator-comments">New Regulator Comments</div>
            </div>
          </div>
        </div>
      }
    </>
  );
};
